import { preferenceNames } from './preference-names';
import { FilterOptionKeys } from '../constants';

const last7Days = (i18n, accountTimeZone) => {
  const today = new Date();
  const weekBack = new Date();
  weekBack.setDate(weekBack.getDate() - 7);
  const formatterOptions = {
    timeZone: accountTimeZone,
    raw: 'yyyy-MM-dd',
  };
  return ({
    // to get the date without time yyyy-MM-dd (10 chars)
    start: i18n.formatDate(weekBack, formatterOptions),
    end: i18n.formatDate(today, formatterOptions),
  });
};

const defaultCalendarPostTypeFilter = [
  FilterOptionKeys.Scheduled,
  FilterOptionKeys.Posted,
  FilterOptionKeys.Failed,
];

export const PreferenceDefaults = (i18n, accountTimeZone) => ({
  [preferenceNames.AdsDateRange]: last7Days(i18n, accountTimeZone),
  [preferenceNames.SocialReportDateRange]: last7Days(i18n, accountTimeZone),
  [preferenceNames.SelectedProfiles]: null,
  [preferenceNames.InboxActivityTypeFilter]: {},
  [preferenceNames.HomeReportDataRange]: last7Days(i18n, accountTimeZone),
  [preferenceNames.SignUpWizard]: {},
  [preferenceNames.CampaignCreationWizards]: {},
  [preferenceNames.SignUpWizardV6]: {},
  [preferenceNames.CampaignCreationWizardsV6]: {},
  [preferenceNames.UpSignUpWizard]: {},
  [preferenceNames.UPCampaignCreationWizards]: {},
  [preferenceNames.SmartPageSignupEntry]: {},
  [preferenceNames.SignUpWizardMode]: {},
  [preferenceNames.CalendarPostTypeFilter]: defaultCalendarPostTypeFilter,
  [preferenceNames.UpStepWizardStep]: {},
  [preferenceNames.SubAdsWizardStep]: {},
  [preferenceNames.UPWizardTermsAndCondition]: {},
  [preferenceNames.SubAdsWizardTermsAndCondition]: {},
  [preferenceNames.UpSpecialCategoryLastModifyTime]: {},
  [preferenceNames.UpBudgetSuggestionsLastModifyTime]: {},
  [preferenceNames.UpSignUpFlowId]: {},
  [preferenceNames.UpMobileAppPrompt]: {
    lastViewTime: undefined,
    countPromptDisplayed: 0,
  },
  [preferenceNames.UpChatBubbleRejectionInfo]: {
    totalTimes: 0,
    lastRejectionTimestamp: undefined,
  },
});
